<template>
    <div  class="z-add-person" v-form="'back-add-person'">
        <div class="double-wrap">
            <div class="left">
                <div class="back-item">
                    <div class="back-title">姓名</div>
                    <div class="back-wrap text">
                        {{ sub.name | empty}}
                    </div>
                </div>

                <div class="back-item">
                    <div class="back-title">账号</div>
                    <div class="back-wrap text">
                        {{ sub.account | empty}}
                    </div>
                </div>

                <div class="back-item">
                    <div class="back-title">工号</div>
                    <div class="back-wrap text">
                        {{ sub.job_num | empty}}
                    </div>
                </div>

            </div>

            <div class="right">
                <div class="back-item">
                    <div class="back-title">入职时间</div>
                    <div class="back-wrap text">
                        {{ sub.work_date | empty}}
                    </div>
                </div>

                <div class="back-item">
                    <div class="back-title">出生日期</div>
                    <div class="back-wrap text">
                        {{ sub.birth_date | empty}}
                    </div>
                </div>

                <div class="back-item">
                    <div class="back-title">手机号码</div>
                    <div class="back-wrap text">
                        {{ sub.phone_num | empty}}
                    </div>
                </div>
            </div>

        </div>

        <!-- 职位属性 -->
        <div class="title">职位属性</div>
        <div class="double-wrap">
            
            <div class="left">
                <div class="back-item">
                    <div class="back-title">岗位</div>
                    <div class="back-wrap text">
                        {{ position_name | empty}}
                    </div>
                </div>

                <div class="back-item">
                    <div class="back-title">职级</div>
                    <div class="back-wrap text">
                        {{ sub.rank | empty}}
                    </div>
                </div>

                <div class="back-item">
                    <div class="back-title">所属BU</div>
                    <div class="back-wrap text">
                        <div>{{ bu_name | empty}}</div>
                    </div>
                </div>

            </div>

            <div class="right">
                <div class="back-item">
                    <div class="back-title">角色</div>
                    <div class="back-wrap text">
                        {{ role_names | empty }}
                        <!-- <div class="check-head">
                            <el-checkbox v-model="check_all"  @change="chooseAll">{{ "全选" }}</el-checkbox>
                        </div>

                        <el-checkbox-group class="role-wrap" v-model="sub.role_ids" v-tar="role_str" @change="roleCheck">
                            <el-checkbox class="role-item" v-for="item in role_list" :key="item.id" :label="item.id">{{ item.displayName }}</el-checkbox>
                        </el-checkbox-group> -->
                    </div>
                </div>
            </div>

        </div>
    </div>
</template>

<script>
    import { mapState } from "vuex";

    export default {
        props:["id",'index'],
        data(){
            return {
                sub:{
                    name:"",       //姓名
                    account:"",    //账号         
                    job_num:"",    //工号
                    work_date:"",  //入职时间
                    birth_date:"", //出生日期
                    phone_num:"",  //手机号码
                    position_id:"",//岗位
                    rank:"",       //职级
                    bu_id:"",      //所属BU
                    role_ids:[],   //角色ids
                },
                check_all:false,

                role_list:[],   //角色列表
                post_list:[],  //岗位列表
                bu_list:[],   //bu列表
                bu_name:"",   //BU名称
            }
        },
        computed:{
            // all_ids(){  //角色列表id最大合集
            //     return this.role_list.map(item => item.id);
            // },
            // role_str(){  //id 拼成string
            //     return this.sub.role_ids.sort().join(',');
            // },
            role_names(){
                return this.sub.role_ids.map(id=>{
                    let name = "";
                    this.role_list.some(role=>{
                        return role.id == id && (name = role.displayName);
                    })
                    return name;
                }).join(',');
            },
            position_name(){
                var name = "";
                this.post_list.some(post=>{
                    return post.id == this.sub.position_id && (name = post.positionName);
                });
                return name;
            }
        },
        filters:{
            empty(text){
                return text?text:"暂无";
            }
        },

        watch:{
            index(val){
                if(val == 4){
                    this.getData();
                }
            },
        },

        created(){
            this.fresh();
        },

        methods:{
            fresh(){
                this.$http.get(`api/admin/role/list`).then(res=>{  // 角色列表
                    if(res.status == 200){
                        this.role_list = res.res_data;
                    }
                });

                this.$http.get(`api/user/position/all`).then(res=>{  //岗位列表
                    if(res.status == 200){
                        this.post_list = res.res_data;
                    }
                });

                // this.$http.get(`api/admin/bu/list/excluderesigned`).then(res=>{  //bu列表
                //     if(res.status == 200){
                //         this.bu_list = res.res_data;
                //     }
                // });
                
                this.getData();
            },
            getData(){
                if(this.id){
                    let url = `api/admin/user/info`;
                    this.$http.get(url,{
                        params:{userId:this.id}
                    }).then(res=>{
                        if(res.status == 200){
                            let data = res.res_data;
                            this.$emit("getdata",{...data});
                            let sub = this.sub;
                            sub.name = data.realName;
                            sub.account = data.mail;
                            sub.job_num = data.userName;
                            sub.work_date = data.workDate;
                            sub.birth_date = data.birthDate;
                            sub.phone_num = data.mobile;
                            sub.position_id = data.positionId;
                            sub.rank = data.staffingGrade;
                            // sub.bu_id = data.bu.id;
                            this.bu_name = data.bu.buName;
                            sub.role_ids = data.roles.map(item=>item.id);

                            // this.roleCheck();
                            // this.$form.init("back-add-person");
                        }
                    })

                }else{
                    this.sub = {
                        name:"",       //姓名
                        account:"",    //账号         
                        job_num:"",    //工号
                        work_date:"",  //入职时间
                        birth_date:"", //出生日期
                        phone_num:"",  //手机号码
                        position_id:"",//岗位
                        rank:"",       //职级
                        bu_id:"",      //所属BU
                        role_ids:[],   //角色ids
                    };
                    // this.roleCheck();
                    this.$form.init("back-add-person");
                }
            },

            // ***多选部分
            // chooseAll(event){  //全选
            //     this.sub.role_ids = event.target.checked?[...this.all_ids]:[];
            // },
            // roleCheck(){  //单选
            //     this.check_all = this.sub.role_ids.length === this.all_ids.length && this.all_ids.length != 0;
            // },
        },
    }
</script>

<style lang="less">
    @import "~src/assets/less/backless/var.less";
    .z-add-person{
        .double-wrap{
            margin-top: 25px;
            overflow: hidden;
            .left,.right{
                float:left;
            }
            .left{
                width:390px;
            }
            .right{
                max-width:calc(~"100% - 390px");
            }
    
            &+.title{
                line-height: 30px;
                font-size:12px;
                color:#8d8d8d;
                border-bottom: 1px solid #ddd;
            }
        }
    
        @left_w:64px;
        .back-item{
            &:after{
                content:"";
                display: block;
                clear: both;
            }
            >div{
                float:left;
            }
            .back-title{
                width:@left_w;
                box-sizing: border-box;
            }
            .back-wrap{
                max-width:calc(~"100% - @{left_w}");
            }
    
            .role-item{
                margin-left:0;
                margin-right: 15px;
                margin-bottom: 15px;
                line-height: @line;
                height:@line;
                .el-checkbox__input{
                    height:100%;
                }
                .el-checkbox__label{
                    font-size:12px;
                }

            }
        }

        .check-head{
            line-height: @line;
            span{
                vertical-align: middle;
            }
        }

        .btns{
            margin-top: 30px;
            padding-left: @left_w;
            font-size:0;
            >.back-btn{
                font-size:14px;
            }
            .back-btn+.back-btn{
                margin-left: 15px;
            }
        }
    }
</style>





// WEBPACK FOOTER //
// personInfo-read.vue?6e9db68b